const API_URL = "https://app.endorselearning.co.uk"

export const partnerApi = `${API_URL}/api/partner`;
export const categoryApi = `${API_URL}/api/all_category`;
export const sattingApi = `${API_URL}/api/setting`;
